import React, { useState } from "react";
import { HiShoppingBag } from "react-icons/hi";
import { IoMdClose } from "react-icons/io";
import { GiHamburgerMenu } from "react-icons/gi";
import { Link } from "react-router-dom";
import { useResultContext } from "../../../src/app";
import { UserAuth } from "../authcontext/Authcontext";

function Nav({ totalItems }) {
  const { user, logout } = UserAuth();

  const { setactive, active } = useResultContext();

  const [truea, settrue] = useState(false);

  function ClickedNav() {
    settrue((prev) => !prev);
  }
  function CloseNav() {
    settrue((prev) => !prev);
  }
  const [style, setStyle] = useState({ display: "block" });
  console.log("setactive", active);
  return (
    <div className="wrapper    top-0 phonex2:mx-0 demitablet:mx-16 tablet:mx-20 fixed inset-x-0 z-[100000]">
      <div className=" left-0 right-0 top-0 backdrop-blur-lg  mb-10    phonex2:transform       items-center    w-full phonex2:text-white phonex2:bg-gray-900 z-50 bg-white/20 font-font font-medium">
        <div className="flex justify-between phonex2:justify-between py-6 phone:py-4 px-0 phonex2:px-4  items-center">
          <div
            onClick={ClickedNav}
            className="hidden  cursor-pointer phonex2:block"
          >
            {truea && <div className=" inset-0 bg-black/20 h-[100vh] fixed" />}

            <div className="absolute w-16 max-h-[1000%] z-10  left-0 bg-primary-100 top-0"></div>
            <div className="h-full  top-0 left-0 flex  z-20  justify-center items-center">
              <GiHamburgerMenu className="h-6  w-6 z-20" />
            </div>
          </div>
          <div onClick={() => setactive(0)} className="cursor-pointer ">
            <Link to="/">
              <a href="/">
                <div className="relative pointer-events-none">
                  <div className="font-font text-[22px] md:text-[27px] leading-3">
                    Citronella
                  </div>
                  <div className="absolute top-[-17px] md:top-[-25px] left-[-20%] -rotate-[25deg]">
                    <img
                      className="h-4 md:h-6"
                      src="/images/logo.png"
                      alt="logo"
                    />
                  </div>
                </div>
              </a>
            </Link>
          </div>

          <div
            className={`phonex2:absolute  ease-in-out  phonex2:duration-500 z-40 phonex2:top-0 phonex2:left-0  phonex2:py-14  phonex2:px-0 phonex2:h-[100vh] phonex2:bg-primary-100 phonex2:w-[80%] ${
              truea
                ? "phonex2:-translate-x-[0%] drop-shadow-[0_135px_135px_rgba(0,0,0,1.25)]"
                : "phonex2:-translate-x-[100%] "
            }`}
          >
            <div className=" justify-center items-center phonex2:space-x-0  phonex2:justify-center phonex2:items-center phonex2:w-full  phonex2:flex phonex2:flex-col">
              <div
                onClick={CloseNav}
                className="bg-white hidden shadow-2xl phonex2:block rounded-full p-4 mb-10 cursor-pointer"
              >
                {" "}
                <IoMdClose className="w-8 h-8  text-primary-100" />
              </div>{" "}
              <Link
                onClick={() => {
                  setactive(0);
                  CloseNav();
                }}
                className={`${
                  active === 0
                    ? " w-full border-b-[3px] pb-[20.5px] phonex2:pb-0 border-primary-100"
                    : "w-full"
                }`}
                to="/"
              >
                <a
                  href="/"
                  className="link link-underline pb-6 link-underline-black  px-4 phonex2:hover:bg-primary-200 phonex2:border-b-[1px] phonex2:flex phonex2:justify-center  phonex2:w-full phonex2:space-y-[30px] phonex2:p-10 phonex2:duration-500"
                >
                  Home
                </a>
              </Link>
              <Link
                onClick={() => {
                  setactive(1);
                  CloseNav();
                }}
                className={`${
                  active === 1
                    ? "w-full phonex2:pb-0 border-b-[3px] pb-[20.5px] border-primary-100"
                    : "w-full"
                }`}
                to="/products"
              >
                <a
                  href="/"
                  className="link link-underline pb-6 link-underline-black px-4 w-full phonex2:hover:bg-primary-200  phonex2:border-b-[1px] phonex2:flex phonex2:justify-center phonex2:w-full phonex2:space-y-[30px] phonex2:p-10 phonex2:duration-500"
                >
                  Products
                </a>
              </Link>
              <Link
                onClick={() => {
                  setactive(2);
                  CloseNav();
                }}
                className={`${
                  active === 2
                    ? "relative w-full  phonex2:pb-0 border-b-[3px] pb-[20.5px] border-primary-100"
                    : "relative w-full"
                }`}
                to="/about-us"
              >
                <a
                  href="/"
                  className="link link-underline pb-6 link-underline-black px-4 phonex2:hover:bg-primary-200  phonex2:border-b-[1px] phonex2:flex phonex2:justify-center  phonex2:w-full phonex2:space-y-[30px] phonex2:p-10 phonex2:duration-500"
                >
                  About Us
                </a>
              </Link>
              <Link
                onClick={() => {
                  setactive(3);
                  CloseNav();
                }}
                className={`${
                  active === 3
                    ? "w-full relative border-b-[3px] pb-[20.5px] phonex2:pb-0 border-primary-100"
                    : "w-full"
                }`}
                to="/contact"
              >
                <a
                  href="/"
                  className="link link-underline pb-6 link-underline-black px-4 phonex2:hover:bg-primary-200  phonex2:border-b-[1px] phonex2:flex phonex2:justify-center  phonex2:w-full phonex2:space-y-[30px] phonex2:p-10 phonex2:duration-500"
                >
                  Contact
                </a>
              </Link>
              {user ? (
                <a
                  onClick={logout}
                  href="/"
                  className="phonex2:hover:bg-red-500 cursor-pointer hidden phonex2:block phonex2:border-b-[1px] phonex2:flex phonex2:justify-center  phonex2:w-full phonex2:space-y-[30px] phonex2:p-10 phonex2:duration-500"
                >
                  Sign Out
                </a>
              ) : (
                <Link className="w-full" to="/SignUp">
                  <a
                    href="/"
                    className="phonex2:hover:bg-primary-200 hidden phonex2:block phonex2:border-b-[1px] phonex2:flex phonex2:justify-center  phonex2:w-full phonex2:space-y-[30px] phonex2:p-10 phonex2:duration-500"
                  >
                    SignUp
                  </a>
                </Link>
              )}
              {user && (
                <div className="bg-gray-900 hidden phonex2:block px-4 justify-center w-full">
                  <span className="w-full my-10 flex justify-center break-all line-clamp-1">
                    Email: {user && user.email}
                  </span>
                </div>
              )}
            </div>
          </div>

          <div className="flex  items-center">
            {user ? (
              <button
                onClick={logout}
                onMouseEnter={(e) => {
                  setStyle({ display: "block" });
                }}
                onMouseLeave={(e) => {
                  setStyle({ display: "none" });
                }}
                className="font-medium phonex2:hidden   hover:bg-gray-900 hover:text-white duration-700 border-2 rounded-md border-gray-900 cursor-pointer px-8 py-2"
              >
                Sign Out
              </button>
            ) : (
              <Link className="w-full" to="/SignUp">
                <button className="font-medium phonex2:hidden   hover:bg-gray-900 hover:text-white duration-700 border-2 rounded-md border-gray-900 cursor-pointer px-8 py-2">
                  Sign Up
                </button>
              </Link>
            )}

            {user && (
              <div className="bg-gray-900 duration-700 group  phonex2:hidden absolute top-20 rounded-md   border-b-2 ">
                <span
                  style={style}
                  className="text-white text-sm bg-gray-900 text-center rounded-md px-8 py-4  z-10  "
                >
                  {user && user.email}{" "}
                </span>
              </div>
            )}
            <Link
              onClick={() => setactive(null)}
              setactive={setactive}
              to="/cart"
            >
              <div className="bg-gray-900 ml-2 z-[1000000] phonex2:ml-0 w-12 h-[43px]  x2:m-0 flex justify-center items-center rounded-md cursor-pointer relative">
                <span className="text-primary-100 bg-white rounded-full w-[22px] h-[22px] justify-center items-center flex absolute top-0 right-0">
                  <div className="flex justify-center items-center">
                    {totalItems}
                  </div>
                </span>
                <HiShoppingBag className="bg-white rounded-full w-8 h-8 p-1 text-gray-900" />
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Nav;
